<script lang="ts">
  import type { Snippet } from 'svelte'

  let {
    children,
    maxWidth = 'max-w-4xl',
    paddingX = 'px-4',
    paddingY = 'py-6',
    paddingBottom = 'pb-20 md:pb-6',
  }: {
    children: Snippet
    maxWidth?: string
    paddingX?: string
    paddingY?: string
    paddingBottom?: string
  } = $props()
</script>

<div class="min-h-screen bg-neutral-50 dark:bg-gray-900">
  <div class="{maxWidth} mx-auto {paddingX} {paddingY} {paddingBottom}">
    {@render children()}
  </div>
</div>
